
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface MatchingCandidatesErrorStateProps {
  error: Error;
}

export const MatchingCandidatesErrorState = ({ error }: MatchingCandidatesErrorStateProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Matching Candidates</CardTitle>
      </CardHeader>
      <CardContent>
         <Alert variant="destructive">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Error fetching suggestions</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};
